import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from 'sections/DigitalTools/ShipSchedules/components/SectionCallToAction/SectionCallToAction.module.scss';

const cn = classNames.bind(styles);

const SectionCallToAction = (): ReactElement => {
  return (
    <section className={cn('cta')}>
      <div className={cn('container')}>
        <div className={cn('cta__box')}>
          <h2 className={cn('cta__heading')}>
            Looking for ways to scale?
          </h2>
          <div className={cn('cta__description')}>
            Find more about the Ship Schedules API’s capabilities
          </div>
          <div className={cn('cta__buttons')}>
            <Link
              className={cn('cta__button-discover')}
              href="/digital-tools"
            >
              Discover Our Digital Tools Now
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionCallToAction;